export const isBetaEnabled = () => localStorage.getItem('betaEnabled') === 'true'
